import React, { useMemo, useState } from 'react';

const renderMarkdown = (text) => {
  if (!text) return '';
  let html = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\n/g, '<br/>');
  return html;
};

const ArticleReaderModal = ({ article, onClose, onFeedback }) => {
  const [showFollowup, setShowFollowup] = useState(false);
  const [comment, setComment] = useState('');
  const body = useMemo(() => renderMarkdown(article?.bodyMarkdown || ''), [article]);

  if (!article) return null;

  return (
    <div className="support-modal-overlay" onClick={onClose}>
      <div className="support-modal" onClick={(event) => event.stopPropagation()}>
        <div className="support-modal-header">
          <div>
            <div style={{ fontSize: '1.1rem', fontWeight: 600 }}>{article.title}</div>
            <div style={{ fontSize: '0.8rem', color: '#9b9b9b' }}>
              Updated {article.updatedAt?.toDate ? article.updatedAt.toDate().toLocaleDateString() : 'recently'}
            </div>
          </div>
          <button className="support-btn" onClick={onClose}>Close</button>
        </div>
        <div className="support-modal-body">
          <div style={{ color: '#e7e7e7', lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: body }} />
          <div style={{ marginTop: '1.5rem' }}>
            <div style={{ marginBottom: '0.5rem', color: '#cfcfcf' }}>Was this helpful?</div>
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button
                className="support-btn"
                onClick={() => {
                  onFeedback(true);
                  setShowFollowup(false);
                }}
              >
                ?? Yes
              </button>
              <button
                className="support-btn"
                onClick={() => {
                  setShowFollowup(true);
                }}
              >
                ?? No
              </button>
            </div>
            {showFollowup && (
              <div style={{ marginTop: '0.75rem' }}>
                <label style={{ fontSize: '0.85rem', color: '#bdbdbd' }}>
                  What were you trying to do?
                </label>
                <textarea
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  rows={3}
                  style={{ width: '100%', marginTop: '0.5rem' }}
                />
                <button
                  style={{ marginTop: '0.5rem' }}
                  className="support-btn primary"
                  onClick={() => {
                    onFeedback(false, comment);
                    setShowFollowup(false);
                    setComment('');
                  }}
                >
                  Send feedback
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleReaderModal;
